export default __webpack_public_path__ + "static/media/img1.0bc394e5.jpg";